import { render, staticRenderFns } from "./Sdk.vue?vue&type=template&id=6ec3aff9&scoped=true"
import script from "./Sdk.vue?vue&type=script&lang=js"
export * from "./Sdk.vue?vue&type=script&lang=js"
import style0 from "./Sdk.vue?vue&type=style&index=0&id=6ec3aff9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec3aff9",
  null
  
)

export default component.exports